/**
 * Lista de instituciones financieras reconocidas por la Superintendencia
 * de Bancos + Superintendencia de Economía Popular y Solidaria (SEPS) del
 * Ecuador. Cubre bancos privados, banca pública y las principales COACs
 * (cooperativas de ahorro y crédito segmento 1 y 2) que reciben depósitos
 * de nómina en el país.
 *
 * Se usa en:
 * - Cargar cuenta bancaria del vendedor (payout)
 * - Cargar cuenta para reembolso manual (buyer refund)
 *
 * Orden: alfabético para no sesgar hacia un banco en particular. Mantener
 * el string EXACTO — el backend guarda estos nombres y admin los busca.
 */
export const ECUADOR_BANKS = [
  // Bancos privados
  "Banco Amazonas",
  "Banco Bolivariano",
  "Banco Capital",
  "Banco ComercialBank",
  "Banco Coopnacional",
  "Banco de Guayaquil",
  "Banco de Loja",
  "Banco de Machala",
  "Banco del Austro",
  "Banco del Litoral",
  "Banco del Pacífico",
  "Banco Delbank",
  "Banco Diners Club del Ecuador",
  "Banco D-Miro",
  "Banco Finca",
  "Banco General Rumiñahui",
  "Banco Internacional",
  "Banco Pichincha",
  "Banco ProCredit",
  "Banco Solidario",
  "Banco VisionFund Ecuador",
  "Produbanco",
  // Banca pública
  "BanEcuador",
  "Corporación Financiera Nacional (CFN)",
  "BIESS",
  // Cooperativas (SEPS Segmento 1) — top uso en nómina
  "Cooperativa Alianza del Valle",
  "Cooperativa Andalucía",
  "Cooperativa Atuntaqui",
  "Cooperativa CACPECO",
  "Cooperativa Cooprogreso",
  "Cooperativa Jardín Azuayo",
  "Cooperativa JEP (Juventud Ecuatoriana Progresista)",
  "Cooperativa Mego",
  "Cooperativa Mushuc Runa",
  "Cooperativa OSCUS",
  "Cooperativa Pablo Muñoz Vega",
  "Cooperativa Policía Nacional",
  "Cooperativa Riobamba",
  "Cooperativa San Francisco",
  "Cooperativa Tulcán",
  "Cooperativa 23 de Julio",
  "Cooperativa 29 de Octubre",
];

/**
 * Valor especial que activa el input de texto libre.
 * Lo aislamos como constante para no depender de un string mágico.
 */
export const BANK_OTHER = "__otro__";
